import React from 'react';
import { Grid, Typography } from '@metarouter-private/mr-mui';

export default function AuditLogFieldHeaderRow() {
  return (
    <Grid container data-test-id="auditLogFieldHeaderRow" spacing={1}>
      <Grid item xs={4} data-test-id="auditLogFieldHeaderName">
        <Typography variant="caption" color="text.secondary" fontWeight="medium">
          Field Name
        </Typography>
      </Grid>
      <Grid item xs={4} data-test-id="auditLogFieldHeaderPrevious">
        <Typography variant="caption" color="text.secondary" fontWeight="medium">
          Previous Value
        </Typography>
      </Grid>
      <Grid item xs={4} data-test-id="auditLogFieldHeaderNew">
        <Typography variant="caption" color="text.secondary" fontWeight="medium">
          New Value
        </Typography>
      </Grid>
    </Grid>
  );
}
